import React, { useState, useEffect } from 'react'

function CopyLinkButton() {
	const [isCopied, setIsCopied] = useState(false)
	const [link, setLink] = useState('')

	useEffect(() => {
		setLink(window.location.href)
	}, [])

	const handleCopy = () => {
		navigator.clipboard
			.writeText(link)
			.then(() => {
				setIsCopied(true)
				setTimeout(() => setIsCopied(false), 3000) // reset after 3 seconds
			})
			.catch((error) => {
				console.error('Failed to copy link: ', error)
			})
	}

	return (
		<a className="btn-text" onClick={handleCopy}>
			{isCopied ? 'Másolva!' : 'Link másolása'}
		</a>
	)
}

export default CopyLinkButton
